export const appConfig = {
  // URL to the user manual. Defaults to a static file served by the frontend.
  manualUrl: process.env.REACT_APP_MANUAL_URL || '/manual.html',
};
